import { render } from "./BillingBarChart.vue?vue&type=template&id=dbc00b6a&scoped=true"
import script from "./BillingBarChart.vue?vue&type=script&lang=js"
export * from "./BillingBarChart.vue?vue&type=script&lang=js"

import "./BillingBarChart.vue?vue&type=style&index=0&id=dbc00b6a&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc00b6a"]])

export default __exports__